/* Sticky add-to-cart bar for the product template.
   Markup: snippets/spd-sticky-atc.liquid — Styles: assets/spd-sticky-atc.css

   The bar owns as little state as possible. Price, stock, button label and the button's
   disabled state are mirrored from the buy box, so every gate the buy box applies (sold
   out, SAS/zoned confirmation checkbox, variant change, in-flight spinner) reaches the
   sticky button without being reimplemented. The add itself runs through the theme's own
   addItemToCart(), which reads the variant from the buy box and the quantity from this
   bar's own form.

   Quantity is the one thing the bar renders itself, matching the buy box: 1-9 in a
   dropdown plus "10+", which swaps to a number input. The real ceiling is applied by
   assets/pdp-qty-limit.js, which treats this bar as a second scope. */

(function () {
  'use strict';

  var bar = document.querySelector('[data-spd-satc]');
  if (!bar || !('IntersectionObserver' in window)) return;

  var form = bar.querySelector('[data-spd-satc-form]');
  var qtyBox = bar.querySelector('[data-spd-satc-qty]');
  var qtyValue = bar.querySelector('[data-spd-satc-qty-value]');
  var btn = bar.querySelector('[data-spd-satc-add]');
  var btnLabel = bar.querySelector('[data-spd-satc-btn-label]');
  var btnPrice = bar.querySelector('[data-spd-satc-btn-price]');
  var priceEl = bar.querySelector('[data-spd-satc-price]');
  var pricePerEl = bar.querySelector('[data-spd-satc-price-per]');
  var stockEl = bar.querySelector('[data-spd-satc-stock]');
  var notifyBtn = bar.querySelector('[data-spd-satc-notify]');

  if (!form || !qtyBox || !qtyValue || !btn) return;

  var seedField = qtyBox.querySelector('[data-spd-satc-qty-field]');
  var qtyLabel = (seedField && seedField.getAttribute('aria-label')) || 'Quantity';
  var pushing = false;

  /* ---------------------------------------------------------------- quantity */

  function qtyField() {
    return qtyBox.querySelector('[data-spd-satc-qty-field]');
  }

  function readQty() {
    var f = qtyField();
    var n = f ? parseInt(f.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  function commit() {
    var n = readQty();
    qtyValue.value = n;
    if (!pushing) pushToBuyBox(n);
  }

  function applyAttrs(el) {
    el.className = 'spd-satc__qty-field';
    el.setAttribute('data-spd-satc-qty-field', '');
    el.setAttribute('aria-label', qtyLabel);
  }

  function makeSelect(value) {
    var sel = document.createElement('select');
    applyAttrs(sel);
    sel.setAttribute('data-quantity-select', '');

    for (var v = 1; v <= 9; v++) {
      var opt = document.createElement('option');
      opt.value = v;
      opt.textContent = v;
      sel.appendChild(opt);
    }
    var ten = document.createElement('option');
    ten.value = '10';
    ten.textContent = '10+';
    ten.setAttribute('data-tenplus', '1');
    sel.appendChild(ten);

    sel.value = String(value > 0 && value < 10 ? value : 1);

    sel.addEventListener('change', function () {
      var picked = sel.options[sel.selectedIndex];
      if (picked && picked.getAttribute('data-tenplus') === '1') {
        swapTo(makeInput(10), true);
      }
      commit();
    });

    return sel;
  }

  function makeInput(value) {
    var input = document.createElement('input');
    input.type = 'number';
    input.min = '1';
    /* Same open ceiling the buy box uses; pdp-qty-limit.js is what clamps to real stock. */
    input.max = '9999';
    input.value = value;
    applyAttrs(input);
    input.setAttribute('data-quantity-input', '');

    input.addEventListener('input', commit);
    input.addEventListener('change', commit);

    input.addEventListener('blur', function () {
      var v = parseInt(input.value, 10);
      if (!v || v < 10) {
        swapTo(makeSelect(v > 0 ? v : 1), false);
        commit();
      }
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        input.blur();
      } else if (e.key === 'Escape') {
        input.value = 1;
        input.blur(); // runs the swap above
        var sel = qtyField();
        if (sel && sel !== input) { try { sel.focus(); } catch (e2) {} }
      }
    });

    return input;
  }

  function swapTo(el, focus) {
    var cur = qtyField();
    if (cur) cur.parentNode.replaceChild(el, cur);
    else qtyBox.insertBefore(el, qtyBox.firstChild);
    if (focus) {
      try {
        el.focus();
        if (el.select) el.select();
      } catch (e) {}
    }
  }

  function setQty(n) {
    n = parseInt(n, 10);
    if (!n || n < 1) n = 1;
    var f = qtyField();
    var wantSelect = n < 10;

    if (!f || (wantSelect ? f.tagName !== 'SELECT' : f.tagName !== 'INPUT')) {
      swapTo(wantSelect ? makeSelect(n) : makeInput(n), false);
    } else {
      f.value = String(n);
    }
    qtyValue.value = n;
  }

  /* Wire the server-rendered select the same way a JS-built one would be. */
  (function initialField() {
    var f = qtyField();
    if (f) swapTo(makeSelect(parseInt(f.value, 10) || 1), false);
  })();

  /* ------------------------------------------------------- buy box quantity */

  function buyBoxQtyField() {
    return document.querySelector('.atc-wrapper [name="quantity"]');
  }

  function fire(el) {
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function pullFromBuyBox() {
    var f = buyBoxQtyField();
    if (!f) return;
    var n = parseInt(f.value, 10);
    if (n > 0 && n !== readQty()) setQty(n);
  }

  /* The buy box's "10+" option swaps its select for a number input inside the custom
     dropdown wrapper, and its own menu handler is what unwraps that. Reaching the same
     state programmatically means repeating the unwrap. If any of this drifts, the add
     is still correct: it reads this bar's own hidden quantity, not the buy box's. */
  function unwrapBuyBoxDropdown() {
    var wrap = document.querySelector('.atc-wrapper .pdp-cdd--qty');
    if (!wrap || wrap.querySelector('select') || !wrap.parentNode) return;
    var replacement = null;
    for (var i = 0; i < wrap.children.length; i++) {
      if (!wrap.children[i].classList.contains('pdp-cdd-display')) replacement = wrap.children[i];
    }
    if (replacement) wrap.parentNode.replaceChild(replacement, wrap);
  }

  function pushToBuyBox(n) {
    var f = buyBoxQtyField();
    if (!f || parseInt(f.value, 10) === n) return;

    /* The buy box focuses its own number input when it swaps on "10+", and that focus
       scrolls the page back up to the buy box, pulling this bar out from under the
       customer mid-edit. Force preventScroll for the length of the push so the swap
       still happens but the viewport stays put. */
    var scrollX = window.scrollX;
    var scrollY = window.scrollY;
    var hadFocus = bar.contains(document.activeElement);
    var nativeFocus = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function () {
      return nativeFocus.call(this, { preventScroll: true });
    };

    pushing = true;
    try {
      if (f.tagName === 'INPUT') {
        f.value = String(n);
        fire(f);
      } else {
        var exact = null;
        var ten = null;
        for (var i = 0; i < f.options.length; i++) {
          if (parseInt(f.options[i].value, 10) === n) exact = f.options[i];
          if (f.options[i].getAttribute('data-tenplus') === '1') ten = f.options[i];
        }
        if (n < 10 && exact) {
          f.selectedIndex = exact.index;
          fire(f);
        } else if (ten) {
          f.selectedIndex = ten.index;
          fire(f);
          unwrapBuyBoxDropdown();
          var swapped = buyBoxQtyField();
          if (swapped && swapped.tagName === 'INPUT') {
            swapped.value = String(n);
            fire(swapped);
          }
        }
      }
    } catch (e) {
      /* no-op */
    } finally {
      HTMLElement.prototype.focus = nativeFocus;
      pushing = false;
    }

    if (window.scrollX !== scrollX || window.scrollY !== scrollY) window.scrollTo(scrollX, scrollY);
    if (hadFocus && !bar.contains(document.activeElement)) {
      var back = qtyField();
      if (back) {
        try {
          back.focus({ preventScroll: true });
        } catch (e) {}
      }
    }
  }

  ['input', 'change'].forEach(function (ev) {
    document.addEventListener(
      ev,
      function (e) {
        var t = e.target;
        if (!t || pushing || bar.contains(t)) return;
        if (t.name === 'quantity') pullFromBuyBox();
      },
      true
    );
  });

  /* -------------------------------------------------- mirror the buy box state */

  function textOf(selector) {
    var el = document.querySelector(selector);
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function setText(el, value) {
    if (el && value && el.textContent !== value) el.textContent = value;
  }

  function syncFromBuyBox() {
    var real = document.querySelector('.product-form--atc-button');

    /* Only the disabled property, not the theme's `disabled` class: on SAS products the
       buy box carries that class while its button stays live, and copying it would grey
       this one out on a product a customer can actually buy. */
    if (real && !btn.classList.contains('processing')) {
      btn.disabled = !!real.disabled;
      var label = real.querySelector('.atc-button--text');
      if (label) setText(btnLabel, label.textContent.replace(/\s+/g, ' ').trim());
    }

    /* Sold out: swap the quantity and the dead Add-to-cart button for whatever
       back-in-stock control the buy box is already showing. Only make the swap once
       such a control is actually on the page, so a product with no notify path keeps
       the plain disabled button rather than an empty bar. */
    var target = notifyTarget();
    var soldOut = !!(real && real.disabled && target);
    bar.classList.toggle('is-soldout', soldOut);
    if (soldOut && notifyBtn && target.tagName === 'BUTTON') {
      setText(notifyBtn, target.textContent.replace(/\s+/g, ' ').trim());
    }

    var price = textOf('.atc-info--price .pdp-price-amount');
    setText(priceEl, price);
    setText(btnPrice, price);
    setText(pricePerEl, textOf('.atc-info--price .price-per'));
    setText(stockEl, textOf('.pdp-stock-indicator'));
  }

  var buyBox = document.querySelector('.atc-wrapper');
  if (buyBox && 'MutationObserver' in window) {
    var syncTimer;
    new MutationObserver(function () {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(syncFromBuyBox, 80);
    }).observe(buyBox, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'disabled']
    });
  }

  /* --------------------------------------------------------- back in stock */

  /* Whichever back-in-stock control the buy box is showing: the Restock Rocket button
     the store uses today, or the theme's own in-stock notification form if that app
     ever goes away. Hidden ones do not count, since neither can be driven blind. */
  function notifyTarget() {
    var cands = document.querySelectorAll('.restock-rocket-button, [data-in-stock-notification-form]');
    for (var i = 0; i < cands.length; i++) {
      var el = cands[i];
      if (bar.contains(el) || el.offsetParent === null) continue;
      return el;
    }
    return null;
  }

  if (notifyBtn) {
    notifyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var target = notifyTarget();
      if (!target) return;

      if (target.tagName === 'BUTTON') {
        target.click();
        return;
      }

      /* A plain form can only be filled where it stands, so take the customer to it. */
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var email = target.querySelector('input[type="email"]');
      if (email) {
        try {
          email.focus({ preventScroll: true });
        } catch (err) {}
      }
    });
  }

  /* ------------------------------------------------------------ add to cart */

  form.addEventListener('submit', function (e) {
    e.preventDefault();
  });

  btn.addEventListener('click', function (e) {
    e.preventDefault();
    if (btn.disabled || btn.classList.contains('processing')) return;

    commit();

    if (typeof window.addItemToCart === 'function') {
      window.addItemToCart(btn);
      return;
    }

    var real = document.querySelector('.product-form--atc-button');
    if (real) {
      pushToBuyBox(readQty());
      real.click();
    }
  });

  /* ------------------------------------------------------------ show / hide */

  var atcTarget =
    document.querySelector('.atc-wrapper .product-form--atc') ||
    document.querySelector('.atc-buttons--form') ||
    document.querySelector('.product-form--atc-button');

  var footers = document.querySelectorAll('footer');
  var footer =
    document.querySelector('.spd-footer') ||
    (footers.length ? footers[footers.length - 1] : null);

  if (!atcTarget) return;

  var formOut = false;
  var footerIn = false;
  var ready = false;

  function update() {
    var on = ready && formOut && !footerIn;
    bar.classList.toggle('is-visible', on);
    // Anything else pinned to the bottom (the chat launcher) reads this to sit above the bar
    // instead of on its title row.
    document.documentElement.style.setProperty('--spd-satc-h', on ? Math.round(bar.offsetHeight) + 'px' : '0px');
  }

  /* The bar covers the bottom of the viewport, so the add-to-cart row counts as out of
     view once it slides underneath. Without that inset the two would fight each other. */
  var formObserver;
  function watchForm() {
    if (formObserver) formObserver.disconnect();
    var inset = Math.round(bar.offsetHeight || 88);
    formObserver = new IntersectionObserver(
      function (entries) {
        formOut = !entries[0].isIntersecting;
        update();
      },
      { rootMargin: '0px 0px -' + inset + 'px 0px', threshold: 0 }
    );
    formObserver.observe(atcTarget);
  }
  watchForm();

  if (footer) {
    new IntersectionObserver(
      function (entries) {
        footerIn = entries[0].isIntersecting;
        update();
      },
      { threshold: 0 }
    ).observe(footer);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { watchForm(); update(); }, 200);
  });

  /* --------------------------------------------------------------- start up */

  syncFromBuyBox();
  pullFromBuyBox();
  ready = true;
  update();

  /* The buy box rebuilds its own quantity control on a timer, so settle once after it. */
  setTimeout(function () {
    pullFromBuyBox();
    syncFromBuyBox();
  }, 1200);
})();
